import React, { useEffect } from "react";
import { useBeforeUnload } from "react-router-dom";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogContentText from "@mui/material/DialogContentText";
import DialogTitle from "@mui/material/DialogTitle";
import Button from "@mui/material/Button";
import { useNavigate } from "react-router-dom";
import { useDispatch } from "react-redux";
import { clearContentForm } from "../../redux/slices/contentSlice/contentForm/contentForm";
import { handleReset } from "../../redux/slices/addNewContentStepsSlice";
import { handleFilePicked } from "../../redux/slices/contentSlice/onedriveContent/onedriveContent";
import { resetAgreementForm } from "../../redux/slices/agreementFormSlice";

const NavigationWarningModal = () => {
  const [isOpen, setIsOpen] = React.useState(false);
  const navigate = useNavigate();
  const dispatch = useDispatch();
  // Handle browser back button
  useEffect(() => {
    const handlePopState = (event) => {
      event.preventDefault();
      setIsOpen(true);
    };

    window.history.pushState(null, "", window.location.pathname);
    window.addEventListener("popstate", handlePopState);

    return () => {
      window.removeEventListener("popstate", handlePopState);
    };
  }, []);

  // Handle browser refresh/close
  useBeforeUnload(
    React.useCallback((event) => {
      event.preventDefault();
      return (event.returnValue = "Are you sure you want to leave this page?");
    }, [])
  );

  const handleStay = () => {
    setIsOpen(false);
    window.history.pushState(null, "", window.location.pathname);
  };

  const handleLeave = () => {
    dispatch(clearContentForm());
    dispatch(resetAgreementForm());
    dispatch(handleFilePicked(false));
    dispatch(handleReset());
    navigate(-2);
  };

  return (
    <Dialog
      open={isOpen}
      onClose={() => {
        setIsOpen(false);
      }}
      aria-labelledby="alert-dialog-title"
      aria-describedby="alert-dialog-description"
    >
      <DialogTitle id="alert-dialog-title">Leave Page?</DialogTitle>
      <DialogContent>
        <DialogContentText id="alert-dialog-description">
          Are you sure you want to leave this page? Your changes may not be
          saved.
        </DialogContentText>
      </DialogContent>
      <DialogActions>
        <Button onClick={handleStay} color="primary">
          Stay on Page
        </Button>
        <Button onClick={handleLeave} color="error" autoFocus>
          Leave Page
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default NavigationWarningModal;
